import React from 'react';

import logoInterOdonto from '../../../../assets/logo1.png';
import logoNotredame from '../../../../assets/logo2.png';

import * as S from './styles';

function CartaOrientacao({ form }) {
    return (
        <>
            <S.ContainerCartaOrientacao>
                <S.Header>
                    <S.LogoGroup>
                        <S.Logo src={logoNotredame} />
                        <S.Divisor />
                        <S.Logo src={logoInterOdonto} />
                    </S.LogoGroup>
                </S.Header>
                <S.BodyCartaOrientacao>
                    <S.TextBoldCapitalize>Carta de orientação ao beneficiário</S.TextBoldCapitalize>

                    <S.TextCartaOrientacao>Prezado(a) Beneficiário(a),</S.TextCartaOrientacao>

                    <S.TextCartaOrientacao>
                        A Agência de Saúde Suplementar (ANS), instituição que regula as atividades das operadoras de
                        planos privados de assistência à saúde, e tem como missão defender o interesse público vem, por
                        meio desta, prestar informações para o preenchimento da DECLARAÇÃO DE SAÚDE.
                    </S.TextCartaOrientacao>

                    <S.BoxText>
                        <S.TextBoldCapitalize>O QUE É A DECLARAÇÃO DE SAÚDE?</S.TextBoldCapitalize>
                        <S.TextCartaOrientacao>
                            É o formulário que acompanha o contrato do Plano de Saúde, onde o beneficiário ou seu
                            representante legal deverá informar as doenças ou lesões preexistentes que saiba ser
                            portador ou sofredor no momento da contratação do plano.
                        </S.TextCartaOrientacao>

                        <S.TextCartaOrientacao>
                            Para o seu preenchimento, o beneficiário tem o direito de ser orientado, gratuitamente, por
                            um médico credenciado/referenciado pela operadora. Se optar por um profissional de sua livre
                            escolha, assumirá o custo desta opção.
                        </S.TextCartaOrientacao>

                        <S.TextCartaOrientacao>
                            Portanto, se beneficiário (você) toma medicamentos regularmente, consulta médicos por
                            problema de saúde do qual conhece o diagnóstico, fez qualquer exame que identificou alguma
                            doença ou lesão, esteve internado ou submeteu-se a alguma cirurgia, DEVE DECLARAR ESTA
                            DOENÇA OU LESÃO.
                        </S.TextCartaOrientacao>
                    </S.BoxText>

                    <S.BoxText>
                        <S.TextBoldCapitalize>
                            AO DECLARAR AS DOENÇAS E/OU LESÕES QUE O BENEFICIÁRIO SAIBA SER PORTADOR NO MOMENTO DA
                            CONTRATAÇÃO
                        </S.TextBoldCapitalize>

                        <ul>
                            <li>
                                <S.TopicsText>
                                    A operadora NÃO poderá impedi-lo de contratar o plano de saúde. Caso isto ocorra,
                                    encaminhe a denúncia à ANS.
                                </S.TopicsText>
                            </li>

                            <li>
                                <S.TopicsText>
                                    A operadora deverá oferecer: cobertura total ou COBERTURA PARCIAL TEMPORÁRIA (CPT),
                                    podendo ainda oferecer o Agravo, que é um acréscimo no valor da mensalidade, pago ao
                                    plano privado de assistência à saúde, para que se possa utilizar toda a cobertura
                                    contratada, após os prazos de carências contratuais.
                                </S.TopicsText>
                            </li>

                            <li>
                                <S.TopicsText>
                                    No Caso de CPT, haverá restrição de cobertura para cirurgias, leitos de alta
                                    tecnologia (UTI, unidade coronariana ou neonatal) e procedimentos de alta
                                    complexidade - PAC (tomografia, ressonância, etc.*) EXCLUSIVAMENTE relacionados à
                                    doença ou lesão declarada, até 24 meses, contados desde a assinatura do contrato.
                                    Após o período máximo de 24 meses da assinatura contratual, a cobertura passará a
                                    ser integral de acordo com o plano contratado.
                                </S.TopicsText>
                            </li>

                            <li>
                                <S.TopicsText>
                                    NÃO haverá restrição de cobertura para consultas médicas, internações não
                                    cirúrgicas, exames e procedimentos que não sejam de alta complexidade, mesmo que
                                    relacionados à doença ou lesão preexistente declarada, desde que cumpridos os prazos
                                    de carência estabelecidas no contrato.
                                </S.TopicsText>
                            </li>

                            <li>
                                <S.TopicsText>
                                    Não caberá alegação posterior de omissão de informação na declaração de Saúde por
                                    parte da operadora para esta doença ou lesão.
                                </S.TopicsText>
                            </li>
                        </ul>
                    </S.BoxText>

                    <S.PageBreak />

                    <S.BoxText>
                        <S.TextBoldCapitalize>
                            AO NÃO DECLARAR AS DOENÇAS E/OU LESÕES QUE O BENEFICIÁRIO SAIBA SER PORTADOR NO MOMENTO DA
                            CONTRATAÇÃO:
                        </S.TextBoldCapitalize>

                        <S.TextCartaOrientacao>
                            <li>
                                A operadora poderá suspeitar de omissão de informação e, neste caso, deverá comunicar
                                imediatamente ao beneficiário, podendo oferecer CPT, ou solicitar abertura de processo
                                administrativo junto à ANS, denunciando a omissão de informação.
                            </li>
                        </S.TextCartaOrientacao>

                        <S.TextCartaOrientacao>
                            <li>
                                Comprovada a omissão de informação pelo beneficiário, a operadora poderá RESCINDIR o
                                contrato por FRAUDE e responsabilizá-lo pelos procedimentos referentes a doença ou lesão
                                não declarada.
                            </li>
                        </S.TextCartaOrientacao>

                        <S.TextCartaOrientacao>
                            <li>
                                Até o julgamento final do processo pela ANS, NÃO poderá ocorrer suspensão do atendimento
                                nem rescisão do contrato. Caso isto ocorra, encaminhe a denuncia à ANS.
                            </li>
                        </S.TextCartaOrientacao>
                    </S.BoxText>

                    <S.BoxText>
                        <S.TextCartaOrientacao>
                            <S.TextBold>ATENÇÃO!</S.TextBold> Se a operadora oferecer redução ou isenção de carência,
                            isto não significa que dará cobertura assistencial para doenças ou lesões que o beneficiário
                            saiba ter no momento da assinatura contratual. Cobertura Parcial Temporária - CPT - NÃO é
                            carência! Portanto, o beneficiário não deve deixar de informar se possui alguma doença ou
                            lesão ao prencher a Declaração de Saúde!
                        </S.TextCartaOrientacao>
                    </S.BoxText>

                    <S.TextCartaOrientacao>
                        * Para consultar a lista completa de procedimentos de alta complexidade - PAC, acesse o Rol de
                        Procedimento e Eventos em Saúde da ANS no endereço eletrônico:
                        <S.TextBold> www.ans.gov.br - Perfil Beneficiário.</S.TextBold>
                        Em caso de dúvidas, entre em contato com a ANS pelo telefone
                        <S.TextBold> 0800-701-9656</S.TextBold> ou consulte a página da ANS -
                        <S.TextBold> www.ans.gov.br - Perfil Beneficiário.</S.TextBold>
                    </S.TextCartaOrientacao>

                    <S.TextCartaOrientacao>Beneficiário</S.TextCartaOrientacao>

                    <S.TextCartaOrientacao>
                        Local
                        <span className="underlines">____________________________________________________________</span>
                        , Data
                        <span className="underlines">___/___/___</span>
                    </S.TextCartaOrientacao>
                    <S.TextCartaOrientacao hasValue>
                        Nome:
                        <S.TextSpacing className="underlines">{form.fullName.value}</S.TextSpacing>
                    </S.TextCartaOrientacao>
                    <S.TextCartaOrientacao hasValue>
                        CPF:
                        <S.TextSpacing className="underlines">{form.cpf.value}</S.TextSpacing>
                    </S.TextCartaOrientacao>
                    <S.TextCartaOrientacao>
                        Assinatura:
                        <span className="underlines">____________________________________________________________</span>
                    </S.TextCartaOrientacao>
                    <S.TextSignature> Nome legível, assinatura e CPF </S.TextSignature>

                    <S.SpacingSignature />

                    <S.TextCartaOrientacao>Intermediário entre a operadora e o beneficiário</S.TextCartaOrientacao>

                    <S.TextCartaOrientacao>
                        Local
                        <span className="underlines">____________________________________________________________</span>
                        , Data
                        <span className="underlines">___/___/___</span>
                    </S.TextCartaOrientacao>
                    <S.TextCartaOrientacao>
                        Nome:
                        <span className="underlines">____________________________________________________________</span>
                    </S.TextCartaOrientacao>
                    <S.TextCartaOrientacao>
                        CPF:
                        <span className="underlines">____________________________________________________________</span>
                    </S.TextCartaOrientacao>
                    <S.TextCartaOrientacao>
                        Assinatura:
                        <span className="underlines">____________________________________________________________</span>
                    </S.TextCartaOrientacao>
                    <S.TextSignature>Nome legível, assinatura e CPF </S.TextSignature>
                </S.BodyCartaOrientacao>
            </S.ContainerCartaOrientacao>
        </>
    );
}

export default CartaOrientacao;
